import { Component , OnInit } from '@angular/core';
import { PageService } from '@services/index';

@Component({
  selector: 'aff-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent {

  public currentLanguage: string;

  constructor(
    private pageService: PageService
  ) {
    this.pageService.getLanguageSelector().subscribe(val => {
      
      this.currentLanguage = val;
    })
  }

  public changeLanguage(lang: string) {
    this.pageService.changePageInfo({ language: lang })
  }

}
